import request from '@/utils/request'
import { wisdomsitePrefix, accountPrefix } from './config'
import { exportExcel } from '@/utils/download'

// 人脸识别
export function siteVerifyDeviceList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyDevice/listByProject',
    method: 'post',
    data
  })
}
export function updateSiteVerifyDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyDevice/updateByProject',
    method: 'post',
    data
  })
}
export function addSiteVerifyDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyDevice/add',
    method: 'post',
    data
  })
}
export function querySiteVerifyDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyDevice/query',
    method: 'post',
    data
  })
}
export function deviceModelInfoList(data) {
  return request({
    url: accountPrefix + '/front/deviceModelInfo/list',
    method: 'post',
    data
  })
}
export function getRemoteInfo(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteVerifyDeviceConfig/getRemoteInfoByProject',
    method: 'post',
    data
  })
}
export function deviceAddAndUpdate(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteVerifyDeviceConfig/addAndUpdateByProject',
    method: 'post',
    data
  })
}
export function getStoreInfo(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteVerifyDeviceConfig/getStoreInfoByProject',
    method: 'post',
    data
  })
}
export function getInspectionStoreInfo(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteInspectionDeviceConfig/getStoreInfoByProject',
    method: 'post',
    data
  })
}
export function remoteOpen(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyDeviceConfig/remoteOpenByProject',
    method: 'post',
    data
  })
}
export function restoreDeviceByProject(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteVerifyDeviceConfig/restoreDeviceByProject',
    method: 'post',
    data
  })
}
export function queryVerifyDevicePersonPageList(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteVerifyDeviceSyn/queryVerifyDevicePersonPageList',
    method: 'post',
    data
  })
}
export function queryVerifyDeviceTemporaryPageList(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteVerifyDeviceSyn/queryVerifyDeviceTemporaryPageList',
    method: 'post',
    data
  })
}
export function getVerifyDeviceExistsPerson(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteVerifyDeviceSyn/getVerifyDeviceExistsPerson',
    method: 'post',
    data
  })
}
export function synVerifyDeviceAllPerson(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteVerifyDeviceSyn/synVerifyDeviceAllPerson',
    method: 'post',
    data
  })
}
export function synVerifyDeviceFailPerson(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteVerifyDeviceSyn/synVerifyDeviceFailPerson',
    method: 'post',
    data
  })
}
export function synVerifyDevicePersons(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyDeviceSyn/synVerifyDevicePersons',
    method: 'post',
    data
  })
}
export function synVerifyDeviceTemporarys(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteVerifyDeviceSyn/synVerifyDeviceTemporarys',
    method: 'post',
    data
  })
}
export function deviceUpgradeByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyDeviceConfig/upgradeByProject',
    method: 'post',
    data
  })
}
export function getDeviceSettingByProject(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteVerifyDeviceConfig/getDeviceSettingByProject',
    method: 'post',
    data
  })
}
export function setDeviceSettingByProject(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteVerifyDeviceConfig/setDeviceSettingByProject',
    method: 'post',
    data
  })
}
export function attendanceLogTriggerByProject(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteVerifyDeviceConfig/attendanceLogTriggerByProject',
    method: 'post',
    data
  })
}
export function getProtocolConfigSettingByProject(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteVerifyDeviceConfig/getProtocolConfigSettingByProject',
    method: 'post',
    data
  })
}
export function setProtocolConfigSettingByProject(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteVerifyDeviceConfig/setProtocolConfigSettingByProject',
    method: 'post',
    data
  })
}
export function verifyDeviceAgreementUpload(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteAgreementUpload/verifyDeviceAgreementUpload',
    method: 'post',
    data
  })
}
export function queryProjectExtend(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteDeviceAgreement/queryProjectExtend',
    method: 'post',
    data
  })
}
export function queryTenementExtend(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteDeviceAgreement/queryTenementExtend',
    method: 'post',
    data
  })
}
export function restoreAiCameraByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiCamera/restoreAiCameraByProject',
    method: 'post',
    data
  })
}

// 采集机

export function siteCollectorDeviceList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCollectorDevice/pageList',
    method: 'post',
    data
  })
}
export function addSiteCollectorDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCollectorDevice/add',
    method: 'post',
    data
  })
}
export function updateSiteCollectorDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCollectorDevice/update',
    method: 'post',
    data
  })
}
export function deleteSiteCollectorDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCollectorDevice/delete',
    method: 'post',
    data
  })
}
// 采集机

// 参建企业列表
export function siteCompanyList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCompany/list',
    method: 'post',
    data
  })
}

// 扬尘降噪
export function siteYcjzDeviceList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteYcjzDevice/queryPageList',
    method: 'post',
    data
  })
}
export function addSiteYcjzDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteYcjzDevice/add',
    method: 'post',
    data
  })
}
export function getWarnSetting(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteYcjzDevice/getWarnSetting',
    method: 'post',
    data
  })
}
export function updateWarnSetting(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteYcjzDevice/updateWarnSetting',
    method: 'post',
    data
  })
}
export function updateSiteYcjzDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteYcjzDevice/update',
    method: 'post',
    data
  })
}
export function deleteSiteYcjzDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteYcjzDevice/delete',
    method: 'post',
    data
  })
}
export function queryCurveDataSiteYcjzDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteYcjzDevice/queryCurveData',
    method: 'post',
    data
  })
}
export function queryTrendData(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteYcjzDevice/queryTrendData',
    method: 'post',
    data
  })
}

// 车牌识别

export function siteLprDeviceList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprDevice/queryPageList',
    method: 'post',
    data
  })
}
export function connectionSiteLprDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprDevice/connection',
    method: 'post',
    data
  })
}
export function addSiteLprDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprDevice/add',
    method: 'post',
    data
  })
}
export function updateSiteLprDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprDevice/update',
    method: 'post',
    data
  })
}
export function deleteSiteLprDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprDevice/delete',
    method: 'post',
    data
  })
}
export function connectSiteLprDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprDevice/refreshStatus',
    method: 'post',
    data
  })
}
export function restartSiteLprDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprDevice/restart',
    method: 'post',
    data
  })
}
export function cutOffSiteLprDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprDevice/cutOff',
    method: 'post',
    data
  })
}
export function siteLprDeviceGetConfigParam(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprDevice/getConfigParam',
    method: 'post',
    data
  })
}
export function siteLprDeviceGetVideoUrl(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprDevice/getVideoUrl',
    method: 'post',
    data
  })
}
export function siteLprDeviceUpdatePWD(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprDevice/updatePWD',
    method: 'post',
    data
  })
}

// 车牌识别白名单

export function queryWhitePageList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprWhiteList/queryWhitePageList',
    method: 'post',
    data
  })
}
export function saveWhitelist(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprWhiteList/saveWhitelist',
    method: 'post',
    data
  })
}
export function whiteDetail(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprWhiteList/whiteListDetail',
    method: 'post',
    data
  })
}
export function deleteWhiteList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprWhiteList/deleteWhiteList',
    method: 'post',
    data
  })
}
export function getWhitelistRule(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprWhiteList/getWhitelistRule',
    method: 'post',
    data
  })
}
export function saveWhitelistRule(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprWhiteList/saveWhitelistRule',
    method: 'post',
    data
  })
}
export function downloadWhiteListTemp(data) {
  return exportExcel(
    wisdomsitePrefix + '/front/siteLprWhiteList/downloadWhiteListTemp',
    data
  )
}
// export function downloadWhiteListTemp(data) {
//   return request({
//     url: wisdomsitePrefix + '/front/siteLprWhiteList/downloadWhiteListTemp',
//     method: 'post',
//     data
//   })
// }
export function importWhiteList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprWhiteList/importWhiteList',
    method: 'post',
    data
  })
}

// 塔吊监控

export function siteCraneDeviceList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCraneDevice/queryPageList',
    method: 'post',
    data
  })
}
export function addSiteCraneDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCraneDevice/add',
    method: 'post',
    data
  })
}
export function siteCraneDeviceQueryDetail(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCraneDevice/queryDetail',
    method: 'post',
    data
  })
}
export function updateSiteCraneDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCraneDevice/update',
    method: 'post',
    data
  })
}
export function deleteSiteCraneDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCraneDevice/delete',
    method: 'post',
    data
  })
}
export function getManagerPhone(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCraneDevice/getManagerPhone',
    method: 'post',
    data
  })
}
export function siteCraneDeviceRunningState(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCraneDevice/runningState',
    method: 'post',
    data
  })
}
export function siteCraneDeviceBaseInfo(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCraneDevice/baseInfo',
    method: 'post',
    data
  })
}
export function siteCraneDeviceParamInfo(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCraneDevice/paramInfo',
    method: 'post',
    data
  })
}
export function queryPersonByCrane(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCraneDevice/queryPersonByCrane',
    method: 'post',
    data
  })
}
export function saveSiteCraneDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCraneDevice/addAndUpdate',
    method: 'post',
    data
  })
}
export function updateCraneVerifyDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCraneDevice/updateVerifyDevice',
    method: 'post',
    data
  })
}

// 升降机

export function siteElevatorDeviceList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteElevatorDevice/queryPageList',
    method: 'post',
    data
  })
}
export function addSiteElevatorDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteElevatorDevice/add',
    method: 'post',
    data
  })
}
export function updateSiteElevatorDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteElevatorDevice/update',
    method: 'post',
    data
  })
}
export function deleteSiteElevatorDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteElevatorDevice/delete',
    method: 'post',
    data
  })
}
export function siteElevatorDeviceQueryDetail(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteElevatorDevice/queryDetail',
    method: 'post',
    data
  })
}
export function siteElevatorDeviceBaseInfo(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteElevatorDevice/baseInfo',
    method: 'post',
    data
  })
}
export function siteElevatorDeviceParamInfo(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteElevatorDevice/paramInfo',
    method: 'post',
    data
  })
}
export function siteElevatorDeviceRunningState(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteElevatorDevice/runningState',
    method: 'post',
    data
  })
}
export function updateElevatorVerifyDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteElevatorDevice/updateVerifyDevice',
    method: 'post',
    data
  })
}
export function queryPersonByElevator(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteElevatorDevice/queryPersonByElevator',
    method: 'post',
    data
  })
}
export function saveSiteElevatorDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteElevatorDevice/addAndUpdate',
    method: 'post',
    data
  })
}

// 视频监控

export function siteMonitorDeviceList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteMonitorDevice/listByProject',
    method: 'post',
    data
  })
}
export function siteMonitorChannelList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteMonitorChannel/listByProject',
    method: 'post',
    data
  })
}
export function getPlayPathByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteMonitorDevice/getPlayPathByProject',
    method: 'post',
    data
  })
}
export function querySiteMonitorDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteMonitorDevice/query',
    method: 'post',
    data
  })
}
export function startControl(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteMonitorChannel/startControl',
    method: 'post',
    data
  })
}
export function siteMonitorAppList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteMonitorApp/list',
    method: 'post',
    data
  })
}
export function stopControl(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteMonitorChannel/stopControl',
    method: 'post',
    data
  })
}
export function exportDeviceByTenement(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteMonitorDevice/exportDeviceByTenement',
    method: 'post',
    data
  })
}
export function updateSiteMonitorDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteMonitorDevice/update',
    method: 'post',
    data
  })
}
export function siteMonitorChannelUpdateByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteMonitorChannel/updateByProject',
    method: 'post',
    data
  })
}

// 配电箱
export function addSiteAepDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAepDevice/add',
    method: 'post',
    data
  })
}
export function siteAepDeviceList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAepDevice/queryPageList',
    method: 'post',
    data
  })
}
export function siteAepDeviceDetail(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAepDevice/detail',
    method: 'post',
    data
  })
}
export function updateSiteAepDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAepDevice/update',
    method: 'post',
    data
  })
}
export function deleteSiteAepDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAepDevice/delete',
    method: 'post',
    data
  })
}
export function getAepDeviceConfigParam(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAepDevice/getAepDeviceConfigParam',
    method: 'post',
    data
  })
}
export function setAepDeviceConfigParam(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAepDevice/setAepDeviceConfigParam',
    method: 'post',
    data
  })
}
export function getAepDeviceRealtime(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAepDevice/getAepDeviceRealtime',
    method: 'post',
    data
  })
}
export function queryRealtimeLogPageList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAepDevice/queryRealtimeLogPageList',
    method: 'post',
    data
  })
}
export function exportAepRealtimeLog(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAepDevice/exportAepRealtimeLog',
    method: 'post',
    data
  })
}
export function queryRealtimeLogData(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAepDevice/queryRealtimeLogData',
    method: 'post',
    data
  })
}
export function emptyManageLogByProject(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteVerifyDeviceConfig/emptyManageLogByProject',
    method: 'post',
    data
  })
}
export function emptyTimeLogByProject(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteVerifyDeviceConfig/emptyTimeLogByProject',
    method: 'post',
    data
  })
}
export function emptyUserEnrollmentDataByProject(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteVerifyDeviceConfig/emptyUserEnrollmentDataByProject',
    method: 'post',
    data
  })
}
// 培训设备
export function siteTrainDeviceList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteTrainDevice/pageList',
    method: 'post',
    data
  })
}
export function updateSiteTrainDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteTrainDevice/update',
    method: 'post',
    data
  })
}
export function getTrainDeviceExistsPerson(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteTrainDevicePersonSyn/getTrainDeviceExistsPerson',
    method: 'post',
    data
  })
}
export function queryTrainDevicePersonPageList(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteTrainDevicePersonSyn/queryTrainDevicePersonPageList',
    method: 'post',
    data
  })
}
export function synTrainDeviceAllPerson(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteTrainDevicePersonSyn/synTrainDeviceAllPerson',
    method: 'post',
    data
  })
}
export function synTrainDeviceFailPerson(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteTrainDevicePersonSyn/synTrainDeviceFailPerson',
    method: 'post',
    data
  })
}
export function synTrainDevicePersons(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteTrainDevicePersonSyn/synTrainDevicePersons',
    method: 'post',
    data
  })
}
// AI摄像头

export function addSiteAiCamera(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiCamera/add',
    method: 'post',
    data
  })
}
export function siteAiCameraList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiCamera/queryPageList',
    method: 'post',
    data
  })
}
export function updateSiteAiCamera(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiCamera/update',
    method: 'post',
    data
  })
}
export function deleteSiteAiCamera(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiCamera/delete',
    method: 'post',
    data
  })
}
export function getExistsPerson(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiCameraSyn/getExistsPerson',
    method: 'post',
    data
  })
}
export function queryPersonPageList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiCameraSyn/queryPersonPageList',
    method: 'post',
    data
  })
}
export function cameraSynVerifyDeviceAllPerson(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiCameraSyn/synAiCameraAllPerson',
    method: 'post',
    data
  })
}
export function cameraSynVerifyDevicePersons(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiCameraSyn/synAiCameraPersons',
    method: 'post',
    data
  })
}
export function synAiCameraFailPerson(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiCameraSyn/synAiCameraFailPerson',
    method: 'post',
    data
  })
}
export function siteAiCameraPersonRecordList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiCameraPersonRecord/listByProject',
    method: 'post',
    data
  })
}
export function siteAiCameraStrangerList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiCameraStranger/listByProject',
    method: 'post',
    data
  })
}
export function siteAiCameraStatistics(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiCameraStatistics/aiCameraData',
    method: 'post',
    data
  })
}
export function getPersonRecordByHour(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteAiCameraPersonRecord/getPersonRecordByHour',
    method: 'post',
    data
  })
}
export function getStrangerRecordByHour(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteAiCameraStranger/getStrangerRecordByHour',
    method: 'post',
    data
  })
}
export function queryStrangerRecordPageList(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteAiCameraStranger/queryStrangerRecordPageList',
    method: 'post',
    data
  })
}
export function queryStrangerPageList(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteAiCameraStrangerInfo/queryStrangerPageList',
    method: 'post',
    data
  })
}
export function exportSiteAiCameraStranger(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiCameraStranger/exportByProject',
    method: 'post',
    data
  })
}
export function exportStrangerRecordByProject(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteAiCameraStranger/exportStrangerRecordByProject',
    method: 'post',
    data
  })
}
export function exportSiteAiCameraPersonRecord(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiCameraPersonRecord/exportByProject',
    method: 'post',
    data
  })
}
export function siteAiCameraVerifyOutInList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiCameraVerifyOutIn/pageByProject',
    method: 'post',
    data
  })
}
export function addSiteAiBox(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiBox/add',
    method: 'post',
    data
  })
}
export function siteAiBoxList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiBox/pageByProject',
    method: 'post',
    data
  })
}
export function updateSiteAiBox(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiBox/update',
    method: 'post',
    data
  })
}
export function deleteSiteAiBox(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiBox/delete',
    method: 'post',
    data
  })
}
export function siteAiBoxAlarmRecordList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiBoxAlarmRecord/pageByProject',
    method: 'post',
    data
  })
}
export function exportSiteAiBoxAlarmRecord(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiBoxAlarmRecord/exportByProject',
    method: 'post',
    data
  })
}
export function aiBoxCameraPage(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiBox/aiBoxCameraPage',
    method: 'post',
    data
  })
}
export function aiBoxBindCamera(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiBox/aiBoxBindCamera',
    method: 'post',
    data
  })
}
export function getAiBoxCameraChannel(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiBox/getAiBoxCameraChannel',
    method: 'post',
    data
  })
}
export function aiBoxUnbindCamera(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiBox/aiBoxUnbindCamera',
    method: 'post',
    data
  })
}

export function getExistsPersonBox(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiBoxDeviceSyn/getExistsPerson',
    method: 'post',
    data
  })
}
export function queryPersonPageListBox(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiBoxDeviceSyn/queryPersonPageList',
    method: 'post',
    data
  })
}
export function boxSynVerifyDeviceAllPerson(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiBoxDeviceSyn/synAiBoxDeviceAllPerson',
    method: 'post',
    data
  })
}
export function boxSynVerifyDevicePersons(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAiBoxDeviceSyn/synAiBoxDevicePersons',
    method: 'post',
    data
  })
}
export function synAiBoxFailPerson(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteAiBoxDeviceSyn/synAiBoxDeviceFailPerson',
    method: 'post',
    data
  })
}
export function getLocationCoordinate(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteVerifyDeviceConfig/getLocationCoordinate',
    method: 'post',
    data
  })
}
export function setLocationCoordinate(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteVerifyDeviceConfig/setLocationCoordinate',
    method: 'post',
    data
  })
}
export function siteVerifyDevicePullPerson(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyDevicePullPerson/pullPerson',
    method: 'post',
    data
  })
}
export function queryDevicePullPersonStatus(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteVerifyDevicePullPerson/queryDevicePullPersonStatus',
    method: 'post',
    data
  })
}
export function queryPullPersonTaskDetail(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteVerifyDevicePullPerson/queryPullPersonTaskDetail',
    method: 'post',
    data
  })
}
export function siteInspectionDeviceList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteInspectionDevice/pageList',
    method: 'post',
    data
  })
}
export function updateSiteInspectionDevice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteInspectionDevice/update',
    method: 'post',
    data
  })
}
export function getInspectionDeviceGPS(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteInspectionDeviceConfig/getGPS',
    method: 'post',
    data
  })
}
export function querySiteProjectPullDevicePersonConfig(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectPullDevicePersonConfig/query',
    method: 'post',
    data
  })
}
export function saveSiteProjectPullDevicePersonConfig(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteProjectPullDevicePersonConfig/saveOrUpdate',
    method: 'post',
    data
  })
}

// 人脸识别盒子
export const siteAiVerifyDeviceList = (data) =>
  request({
    url: wisdomsitePrefix + '/front/siteAiVerifyDevice/pageList',
    method: 'post',
    data
  })
export const addSiteAiVerifyDevice = (data) =>
  request({
    url: wisdomsitePrefix + '/front/siteAiVerifyDevice/add',
    method: 'post',
    data
  })
export const deleteSiteAiVerifyDevice = (data) =>
  request({
    url: wisdomsitePrefix + '/front/siteAiVerifyDevice/delete',
    method: 'post',
    data
  })
export const updateSiteAiVerifyDevice = (data) =>
  request({
    url: wisdomsitePrefix + '/front/siteAiVerifyDevice/update',
    method: 'post',
    data
  })
export const getAiVerifyDeviceExistsPerson = (data) =>
  request({
    url:
      wisdomsitePrefix +
      '/front/siteAiVerifyDeviceSyn/getVerifyDeviceExistsPerson',
    method: 'post',
    data
  })
export const queryAiVerifyDevicePersonPageList = (data) =>
  request({
    url:
      wisdomsitePrefix +
      '/front/siteAiVerifyDeviceSyn/queryVerifyDevicePersonPageList',
    method: 'post',
    data
  })
export const synAllAiDeviceByProject = (data) =>
  request({
    url:
      wisdomsitePrefix + '/front/siteAiVerifyDeviceSyn/synAllDeviceByProject',
    method: 'post',
    data
  })
export const synAiVerifyDeviceAllPerson = (data) =>
  request({
    url:
      wisdomsitePrefix +
      '/front/siteAiVerifyDeviceSyn/synVerifyDeviceAllPerson',
    method: 'post',
    data
  })
export const synAiVerifyDeviceFailPerson = (data) =>
  request({
    url:
      wisdomsitePrefix +
      '/front/siteAiVerifyDeviceSyn/synVerifyDeviceFailPerson',
    method: 'post',
    data
  })
export const synAiVerifyDevicePersons = (data) =>
  request({
    url:
      wisdomsitePrefix + '/front/siteAiVerifyDeviceSyn/synVerifyDevicePersons',
    method: 'post',
    data
  })
export const siteAiVerifyStrangerList = (data) =>
  request({
    url: wisdomsitePrefix + '/front/siteAiVerifyStranger/pageList',
    method: 'post',
    data
  })
export const siteAiVerifyDeviceChannelList = (data) =>
  request({
    url: wisdomsitePrefix + '/front/siteAiVerifyDeviceChannel/pageList',
    method: 'post',
    data
  })
export const siteAiVerifyPersonRecordList = (data) =>
  request({
    url: wisdomsitePrefix + '/front/siteAiVerifyPersonRecord/pageList',
    method: 'post',
    data
  })
export const siteAiVerifyStrangerRecordList = (data) =>
  request({
    url: wisdomsitePrefix + '/front/siteAiVerifyStrangerRecord/pageList',
    method: 'post',
    data
  })
export const siteAiVerifyStrangerOutInCountRecordList = (data) =>
  request({
    url:
      wisdomsitePrefix + '/front/siteAiVerifyStrangerOutInCountRecord/pageList',
    method: 'post',
    data
  })
export const siteAiVerifyPersonOutInCountRecordList = (data) =>
  request({
    url:
      wisdomsitePrefix + '/front/siteAiVerifyPersonOutInCountRecord/pageList',
    method: 'post',
    data
  })
export const siteAiVerifySnapRecordList = (data) =>
  request({
    url: wisdomsitePrefix + '/front/siteAiVerifySnapRecord/pageList',
    method: 'post',
    data
  })
export const exportSiteAiVerifyPersonOutInCountRecord = (data) =>
  request({
    url:
      wisdomsitePrefix +
      '/front/siteAiVerifyPersonOutInCountRecord/exportByProject',
    method: 'post',
    data
  })
export const exportSiteAiVerifyStrangerOutInCountRecord = (data) =>
  request({
    url:
      wisdomsitePrefix +
      '/front/siteAiVerifyStrangerOutInCountRecord/exportByProject',
    method: 'post',
    data
  })
export const exportSiteAiVerifyPersonRecord = (data) =>
  request({
    url: wisdomsitePrefix + '/front/siteAiVerifyPersonRecord/exportByProject',
    method: 'post',
    data
  })
export const exportSiteAiVerifyStrangerRecord = (data) =>
  request({
    url: wisdomsitePrefix + '/front/siteAiVerifyStrangerRecord/exportByProject',
    method: 'post',
    data
  })
export const exportSiteAiVerifySnapRecord = (data) =>
  request({
    url: wisdomsitePrefix + '/front/siteAiVerifySnapRecord/exportByProject',
    method: 'post',
    data
  })
export const siteProjectAiBoxAlarmDetailList = (data) =>
  request({
    url: wisdomsitePrefix + '/front/siteProjectAiBoxAlarmDetail/pageList',
    method: 'post',
    data
  })
export const exportSiteProjectAiBoxAlarmDetail = (data) =>
  request({
    url:
      wisdomsitePrefix + '/front/siteProjectAiBoxAlarmDetail/exportByProject',
    method: 'post',
    data
  })
export const siteProjectCaAttendanceRangeList = (data) =>
  request({
    url: wisdomsitePrefix + '/front/siteProjectCaAttendanceRange/list',
    method: 'post',
    data
  })
